import { useCallback } from 'react';
import { useTranslations } from 'js/hooks/i18n';
import { ERRORS } from 'js/components/main/ReCaptcha';

export const useRecaptchaErrorHandler = ({ setError, hideRecaptcha }) => {
    const t = useTranslations('playtech.mobile.system.recaptcha.');

    return useCallback(({ errorCode }) => {
        if (errorCode === ERRORS.SCRIPT_LOADING_ERROR.errorCode) {
            hideRecaptcha();
        }

        setError(t('error.technicalError'));
    }, [hideRecaptcha, setError, t]);
};
